import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {
  SubjectResponse,
  SubjectsClient,
  SubjectUpdateRequest
} from "../../../generated-client/generated-api-client";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {ErrorProcessorService} from "../../../services/error-processor.service";
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-subject-edit',
  templateUrl: './subject-edit.component.html',
  styleUrls: ['./subject-edit.component.sass']
})
export class SubjectEditComponent implements OnInit {

  id: string;
  response!: Observable<SubjectResponse>;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private router: Router,
    private client: SubjectsClient,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    this.id = '';
    this.titleService.setTitle('Vizsgatárgy módosítása');
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this.response = this.client.get(this.id);
  }

  async onSubmit(form: FormGroup): Promise<void> {
    const request: SubjectUpdateRequest = {
      id: form.get('id')?.value === '' ? null : form.get('id')?.value,
      defaultGrossTimeLimitMinutes: form.get('defaultGrossTimeLimitMinutes')?.value === ''
        ? null
        : form.get('defaultGrossTimeLimitMinutes')?.value
    };
    const response = await this.client.edit(request);
    response.subscribe(
      next => {
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/subjects/']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
